<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { useInboundDeliveryStore } from '../stores/inboundDeliveryStore';
import { useRefreshInboundDeliveryStore } from '../stores/refreshInboundDeliveryStore';
import { useDeleteInboundDeliveryApi } from '../api/deleteInboundDeliveryApi';
import { Assert } from 'shared/assert';
import DeleteEntityDialog from '@/common/components/DeleteEntityDialog.vue';


const dialog = useTemplateRef('dialog');

defineExpose({
  show
});

const deleteApi = useDeleteInboundDeliveryApi();
const store = useInboundDeliveryStore();
const refreshStore = useRefreshInboundDeliveryStore();

function show(id: string) {
  dialog.value?.show(id);
}

async function onDelete(id: string) {
  const response = await deleteApi.execute({id});
  return response;
}

async function getById(id: string) {
  await refreshStore.initialize();
  const entity = store.getById(id);
  Assert.definied(entity);
  return {
    id: entity.id,
    name: entity.name
  };
}

</script>

<template>
  <DeleteEntityDialog
    ref="dialog"
    :delete="onDelete"
    :get-by-id="getById"
    :translate="(t) => t.inboundDelivery.deleteDialog">
  </DeleteEntityDialog>
</template>
